// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectPopHeader[data-v-42133b94]{width:calc(100% + 40px);background:#fff;margin-left:-20px;height:50px;float:left;border-bottom:1px solid #ccc;padding:10px 15px}.activeCabinet[data-v-42133b94]{background-color:rgba(135,157,201,.3137254901960784)!important}", ""]);
// Exports
module.exports = exports;
